import React from "react";
import { IconProps } from "./IconProps";

const Dots3: React.FC<IconProps> = ({
    size = 22,
    color = "#F7F9F9",
    ...props
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 21 22"
            fill="none"
            {...props}
        >
            <path
                d="M10.9615 11C11.4218 10.9991 11.7942 10.6253 11.7933 10.165C11.7924 9.7048 11.4186 9.33242 10.9583 9.3333C10.4981 9.33419 10.1257 9.708 10.1266 10.1682C10.1275 10.6285 10.5013 11.0009 10.9615 11Z"
                fill={color}
            />
            <path
                d="M10.9503 5.16665C11.4105 5.16576 11.7829 4.79195 11.782 4.33171C11.7812 3.87147 11.4073 3.4991 10.9471 3.49998C10.4869 3.50087 10.1145 3.87468 10.1154 4.33492C10.1163 4.79516 10.4901 5.16753 10.9503 5.16665Z"
                fill={color}
            />
            <path
                d="M10.9728 16.8333C11.433 16.8324 11.8054 16.4586 11.8045 15.9984C11.8036 15.5381 11.4298 15.1657 10.9696 15.1666C10.5093 15.1675 10.1369 15.5413 10.1378 16.0016C10.1387 16.4618 10.5125 16.8342 10.9728 16.8333Z"
                fill={color}
            />
            <path
                d="M10.9615 11C11.4218 10.9991 11.7942 10.6253 11.7933 10.165C11.7924 9.7048 11.4186 9.33242 10.9583 9.3333C10.4981 9.33419 10.1257 9.708 10.1266 10.1682C10.1275 10.6285 10.5013 11.0009 10.9615 11Z"
                stroke={color}
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.9503 5.16665C11.4105 5.16576 11.7829 4.79195 11.782 4.33171C11.7812 3.87147 11.4073 3.4991 10.9471 3.49998C10.4869 3.50087 10.1145 3.87468 10.1154 4.33492C10.1163 4.79516 10.4901 5.16753 10.9503 5.16665Z"
                stroke={color}
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.9728 16.8333C11.433 16.8324 11.8054 16.4586 11.8045 15.9984C11.8036 15.5381 11.4298 15.1657 10.9696 15.1666C10.5093 15.1675 10.1369 15.5413 10.1378 16.0016C10.1387 16.4618 10.5125 16.8342 10.9728 16.8333Z"
                stroke={color}
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Dots3;
